import {Component, Injector, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {DynamicBarService} from "../../../_components/dynamic-bar/dynamic-bar.service";

@Component({
    selector: 'estudio-resumen-barra',
    standalone: false,
    template: `
        <div class="header-mainInfo">
            <h1>{{hijo.nombresApellidos}}</h1>
            <span class="header-mainInfo__separator">/</span>
            <h1 class="">{{seccion}}</h1>
        </div>`
})

export class FamiliaHijoBarraComponent implements OnInit {

    hijo;
    seccion: string = "";

    constructor(private router: Router,
                private injector: Injector) {
    }

    ngOnInit() {
        this.hijo = this.injector.get('alumno');
        this.seccion = this.router.url.indexOf('materias') > -1 ? 'Materias' : 'Unidades';

        this.router.events.subscribe(evt => {
            if(evt instanceof NavigationEnd){
                this.seccion = evt.url.indexOf('materias') > -1 ? 'Materias' : 'Unidades';
            }
        });

    }
}